/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { SECTION_ITEM_STARRED, SECTION_ITEM_RECENT } from '../constants/analytics/section-type.tsx';

export const getSectionByStarredOrRecent = ({
	starred,
	recent,
}: {
	starred: boolean | null | undefined;
	recent: boolean;
}): 'starred' | 'recent' | '' => {
	if (starred) {
		return SECTION_ITEM_STARRED;
	}
	if (recent) {
		return SECTION_ITEM_RECENT;
	}
	return '';
};
